import React from 'react';
import {Button, Stack} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';

import {ChangeFlowVariantEnum} from 'presentation/pages/private/booking/components/ChangeFlowDialog/constants';
import {NetworkTypesEnum} from 'domain/usecases';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {SupportAccreditedNetworkProps} from './types';
import {UnitGrid} from '../UnitGrid';
import {NetworkHeader} from '../NetworkHeader';
import {useUnitList} from '../../hooks/useUnitList';

const {accreditedNetwork, changeAppointmentLocal} =
	translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function SupportAccreditedNetwork({
	list,
	flowType,
	handleNextStep,
}: SupportAccreditedNetworkProps) {
	const {isMobile} = useMediaQueries();
	const {handleChangeModals} = useBookingSummary();

	const {
		supportAccreditNetworkList,
		supportAccreditNetworkListIsEmpty,
		shouldHideFilterResultTitleInSupportAccreditedNetwork,
		showDistanceReferenceInSupportAccreditedNetwork,
	} = useUnitList({list, flowType, networkType: NetworkTypesEnum.ACCREDITED});

	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();

	if (supportAccreditNetworkListIsEmpty) {
		if (query) return null;

		return (
			<Stack gap={2}>
				<NetworkHeader
					title={accreditedNetwork.title}
					description={accreditedNetwork.emptyDescription}
				/>
				<Button
					variant="outlined"
					sx={{width: isMobile ? '100%' : '330px', ml: 'auto'}}
					size="large"
					onClick={() => handleChangeModals(ChangeFlowVariantEnum.LOCATION)}
					data-tag-id={AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO}>
					{changeAppointmentLocal}
				</Button>
			</Stack>
		);
	}

	return (
		<Stack gap={2}>
			<UnitGrid
				list={supportAccreditNetworkList}
				handleNext={handleNextStep}
				flowType={flowType}
				isNotSelfNetwork
				showDistanceReference={showDistanceReferenceInSupportAccreditedNetwork}
				hideFilterResultTitle={shouldHideFilterResultTitleInSupportAccreditedNetwork}>
				<NetworkHeader
					title={accreditedNetwork.title}
					description={accreditedNetwork.phoneScheduleDescription}
				/>
			</UnitGrid>
		</Stack>
	);
}
